import { useTranslation } from 'react-i18next';
import Icon from '../shared/Icon';
import { useReveal } from '../../hooks/useReveal';

export default function CTA() {
  const { t } = useTranslation();
  const ref = useReveal({ stagger: 0.08 });

  return (
    <section
      ref={ref}
      className="section"
      style={{
        background: 'url("/assets/farm_drone_2.webp") center/cover',
        borderBottom: '1px solid var(--p2a-dark-border)',
        position: 'relative',
      }}
    >
      <div style={{
        position: 'absolute', inset: 0,
        background: 'linear-gradient(90deg, rgba(5,7,10,0.9) 0%, rgba(5,7,10,0.6) 60%, rgba(5,7,10,0.3) 100%)',
      }} />
      <div className="p2-container" style={{ position: 'relative' }}>
        <div style={{ maxWidth: 620 }}>
          <div className="eyebrow reveal" style={{ marginBottom: 20 }}>
            <span className="dot" />{t('home.final_cta.eyebrow')}
          </div>
          <h2 className="h-1 reveal">
            {t('home.final_cta.title_line1')} <br />
            <span style={{ color: 'var(--p2a-green-400)' }}>{t('home.final_cta.title_line2_highlight')}</span>
          </h2>
          <p className="reveal" style={{ marginTop: 20, fontSize: 17, lineHeight: 1.55, color: 'var(--p2a-dark-fg-2)', maxWidth: 520 }}>
            {t('home.final_cta.lede')}
          </p>
          <div className="reveal" style={{ display: 'flex', gap: 12, marginTop: 32, flexWrap: 'wrap' }}>
            <a
              href="https://api.whatsapp.com/send?phone=5519996542014&text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20uma%20demonstra%C3%A7%C3%A3o%20das%20solu%C3%A7%C3%B5es%20da%20Pix2Agro."
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              {t('home.final_cta.cta_primary')} <Icon.ArrowRight />
            </a>
            <a href="https://wa.me/5519996542014" target="_blank" rel="noopener noreferrer" className="btn btn-ghost">
              <Icon.Whatsapp width={14} height={14} /> {t('home.final_cta.cta_secondary')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
